import { Component } from "omi";

export class PureComponent<T = object> extends Component<T> {
  receiveProps() {
    // Stop unnecessary renders.
    return false;
  }
}
